import {observable, action, runInAction} from 'mobx'
import {PAGE_SIZE_DEFAULT} from '../constants/appConstant'
import emailAddressAPI from '../apis/emailAddressAPI'
import alertMessage from '../utils/alertMessage'

export default class EmailAddressStore {
  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @observable isFetching = false
  @observable pageSize = PAGE_SIZE_DEFAULT
  @observable pageNo = 1
  @observable currIndex = 0
  @observable itemCount = 0
  @observable pageSizeLog = PAGE_SIZE_DEFAULT
  @observable pageNoLog = 1
  @observable currIndexLog = 0
  @observable inBoundNameList = []

  /*SearchResult start*/
  @observable searchItem = {
    'marketGroupId': '',
    'page': this.pageNo,
    'size': this.pageSize,
  }
  @observable jobList = []
  @action
  async onSearchJobAction(params) {
    this.isFetching = true
    this.jobList = []
    this.pageNo = params.page
    this.pageSize = params.size
    this.itemCount = 0
    try {
      const response = await emailAddressAPI.searchAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.jobList = response.data?.data || []
          this.itemCount = response.data?.data?.length
          this.searchItem = params
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }
  @action
  onChangeJob(value) {
    this.jobList = value
    this.itemCount = 0
  }

  // 获取营销分组列表
  @observable groupList = []
  @action
  async onGetGroup(params) {
    this.groupList = []
    try {
      const response = await emailAddressAPI.getGroup(params)
      const {code, data, messageEn} = response?.data

      runInAction(() => {
        if (code === 0) {
          this.groupList = data
        } else {
          alertMessage.error('失败！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
      })
    }
  }

  /*SearchResult end*/

  /*add*/
  @action
  async onAddJobAction(params, title) {
    this.isFetching = true
    try {
      const response = await emailAddressAPI.addAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data?.code === 0) {
          alertMessage.success(title === 'edit' ? '编辑成功！' : '添加成功！')
          this.onSearchJobAction(this.searchItem)
        } else {
          alertMessage.error(title === 'edit' ? '编辑失败！' + response.data?.messageEn : '添加失败！' + response.data?.messageEn)
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }
  /*edit*/
  @action
  async onEditJobAction(params, title) {
    this.isFetching = true
    try {
      const response = await emailAddressAPI.editAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data?.code === 0) {
          alertMessage.success(title === 'edit' ? 'Edit Success！' : 'Add Success！')
          this.onSearchJobAction(this.searchItem)
        } else {
          alertMessage.error(title === 'edit' ? 'Edit Failed！' + response.data?.messageEn : 'Add Failed！' + response.data?.messageEn)
        }
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*get edit*/
  @observable detailsObj = null

  @action
  async onGetJobAction(params) {
    this.isFetching = true
    try {
      const response = await emailAddressAPI.getAction(params)
      runInAction(() => {
        this.isFetching = false
        const {data} = response.data
        if (response.data.code === 0) {
          this.detailsObj = data || null
        }
      })
      return response.data.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*delete*/
  @action
  async onDeleteJobAction(params) {
    this.isFetching = true
    try {
      const response = await emailAddressAPI.deleteAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('删除成功！')
          this.onSearchJobAction({
            ...this.searchItem,
            'page': 1,
            'size': PAGE_SIZE_DEFAULT,
          })
        } else {
          alertMessage.error('删除失败！' + response.data.messageEn + '')
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  onChangePageNumAction(pageNo, pageSize) {
    if (this.pageNo === pageNo && (!pageSize || this.pageSize === pageSize)) {
      return
    }
    runInAction(() => {
      this.pageNo = pageNo
      this.pageSize = pageSize
    })
    this.onSearchJobAction({
      ...this.this.searchItem,
      'page': pageNo,
      'size': pageSize,
    })
  }

  
    /* 查看地址 地址详情 */
    @observable isFetchingDetails = false
    @observable pageSizeDetails = PAGE_SIZE_DEFAULT
    @observable pageNoDetails = 1
    @observable currIndexDetails = 0
    @observable itemCountDetails = 0
    @observable searchItemDetails = {
      "keyword": "",
      "marketGroupId": this.searchItem?.marketGroupId,
      'page': 1,
      'size': PAGE_SIZE_DEFAULT
    }
    @observable detailsList = []
    @action
    async onDetailsListAction(params) {
      this.isFetchingDetails = true
      this.pageNoDetails = params.page
      this.pageSizeDetails = params.size
      this.itemCountDetails = 0
      this.detailsList = []
      try {
        const response = await emailAddressAPI.getAddressList(params)
        runInAction(() => {
          this.isFetchingDetails = false
          if (response.data.code === 0) {
            this.searchItemDetails = params
            this.detailsList = response.data.data?.addrList
            this.itemCountDetails = response.data.data?.totalNum
          }
        })
        return response
      } catch (err) {
        alertMessage.error('处理异常！'+err.message)
        runInAction(() => {
          this.isFetchingDetails = false
        })
      }
    }
    @action
    onChangeDetailsList(val){
      this.detailsList = val
      this.pageNoDetails = 0
      this.pageSizeDetails = PAGE_SIZE_DEFAULT
      this.itemCountDetails = 0
    }
    @action
    onChangeDetailsPageNumAction(pageNo, pageSize) {
      if (this.pageNoDetails === pageNo && (!pageSize || this.pageSizeDetails === pageSize)) {
        return
      }
      runInAction(() => {
        this.pageNoDetails = pageNo
        this.pageSizeDetails = pageSize
      })
    }
    /* 清空号码 */
    @action
    async onClearAction(params) {
      this.isFetchingDetails = true
      try {
        const response = await emailAddressAPI.clearAction(params)
        runInAction(() => {
          this.isFetchingDetails = false
          if (response.data.code === 0) {
            alertMessage.success('清空成功！')
            this.onDetailsListAction(this.searchItemDetails)
          } else {
            alertMessage.error('清空失败！' + response.data.messageEn + '')
          }
        })
        return response
      } catch (err) {
        alertMessage.error('处理异常！'+err.message)
        runInAction(() => {
          this.isFetchingDetails = false
        })
      }
    }
      
  /*add*/
  @observable isFetchingAdd = false
  @action
  async onAddAddressAction(params, title) {
    this.isFetchingAdd = true
    try {
      const response = await emailAddressAPI.addAddressAction(params)
      runInAction(() => {
        this.isFetchingAdd = false
        if (response.data?.code === 0) {
          alertMessage.success(response.data?.data)
          // this.onDetailsListAction(this.searchItemDetails)
        } else {
          alertMessage.error(title === 'edit' ? '编辑失败！' + response.data?.messageEn : '添加失败！' + response.data?.messageEn)
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetchingAdd = false
      })
    }
  }
  /*delete*/
  @action
  async onDeleteAddressAction(params) {
    this.isFetchingDetails = true
    try {
      const response = await emailAddressAPI.deleteAddressAction(params)
      runInAction(() => {
        this.isFetchingDetails = false
        if (response.data.code === 0) {
          alertMessage.success('删除成功！')
          this.onDetailsListAction(this.searchItemDetails)
        } else {
          alertMessage.error('删除失败！' + response.data.messageEn + '')
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetchingDetails = false
      })
    }
  }
  //获取资源池的 下拉列表
  @observable resourcePoolList = []
  @action
  async onGetResourcePool(params) {
    this.resourcePoolList = []
    try {
      const response = await emailAddressAPI.getResourcePool(params)
      const {code, data, messageEn} = response?.data
      runInAction(() => {
        if (code === 0) {
          this.resourcePoolList = data.filter(a=>a?.status===0)
        } else {
          alertMessage.error('失败！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
      })
    }
  }
}
